import React, { useId } from "react";
import { useAppStatusTransitions } from "@/hooks/queries";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const ALL_STATUSES = "__all__";

interface AppStatusFilterProps {
  value: string;
  onStatusSelect: (status: string) => void;
}

/** Every backend status, with its backend label, in backend order. */
const AppStatusFilter: React.FC<AppStatusFilterProps> = ({ value, onStatusSelect }) => {
  const { choices } = useAppStatusTransitions();
  const selected = choices.some((choice) => choice.value === value) ? value : ALL_STATUSES;
  const labelId = useId();

  return (
    <div className="flex w-full flex-col gap-1 sm:w-[180px]">
      <span id={labelId} className="text-xs font-medium text-muted-foreground">
        Status
      </span>
      <Select value={selected} onValueChange={(v) => onStatusSelect(v === ALL_STATUSES ? "" : v)}>
        {/* Named by the visible label; the selected status is read as its value. */}
        <SelectTrigger aria-labelledby={labelId} className="w-full bg-background">
          <SelectValue placeholder="All Statuses" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={ALL_STATUSES}>All Statuses</SelectItem>
          {choices.map(({ value: status, label }) => (
            <SelectItem key={status} value={status}>
              {label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default AppStatusFilter;
